import singleSpaVue from 'single-spa-vue';

type SingleSpaLifeCycle = ReturnType<typeof singleSpaVue>;

let mounted = false;

export function isAppMounted() {
  return mounted;
}

export function wrapSingleSpaLifeCycle({ mount, unmount, ...rest }: SingleSpaLifeCycle): SingleSpaLifeCycle {
  return {
    mount: async singleSpaProps => {
      mounted = true;
      return mount(singleSpaProps);
    },
    unmount: async singleSpaProps => {
      mounted = false;
      return unmount(singleSpaProps);
    },
    ...rest,
  };
}
